<template>
  <!-- .lo live-online -->
  <div class="lo" :class="isLive ? 'ly' : ''">
    <!-- <div class="lo-title">在线观众</div> -->
    <template v-if="dataList.length">
      <List v-model="loading" :finished="finished" @load="loadMore">
        <div class="lo-item" v-for="(item,index) in dataList" :key="index" @click="linkTo(item)">
          <div class="loi-info">
            <img class="avatarUrl" :src="JSON.parse(item.userInfo).avatarUrl"  v-if="JSON.parse(item.userInfo).avatarUrl" />
            <span class="flag-icon avatarUrl" v-else-if="item.ipFlagStyle" :class="'flag-icon-'+item.ipFlagStyle"></span>
            <img class="avatarUrl" src="@assets/img/empty.png" v-else />
            <span>{{JSON.parse(item.userInfo).name || JSON.parse(item.userInfo).nickName || '游客'}}</span>
          </div>
          <div class="loi-box">
            <div class="loi-brand" v-if="false && item.helperMoney">
              <img src="@assets/img/live/mydou.png" />{{$service.getCount(item.helperMoney)}}
            </div>
            <div class="loi-brand" v-if="item.likeCount">
              <img src="@assets/img/new/icon-zs.png" />{{$service.getCount(item.likeCount)}}
            </div>
          </div>
        </div>

        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </template>
    <div class="u-empty" v-else>暂无数据</div>
    <div style="height: 49px;"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { List } from "vant";
import gql from 'graphql-tag'
export default {
  name: "live-online",
  props:['isLive'],
  data() {
    return {
      loading: false,
      finished: false,
      pageIndex:1,
      pageSize:20,
      dataList:[],
      queryLiveViewer:{},
    };
  },
  computed:{
    ...mapGetters({
      exhibitionId:'getExhibitionId',
    }),
    query() {
      return this.$router.history.current.query;
    },
    online(){
      return  gql`query queryLiveViewer($query: QueryInput!){
            queryLiveViewer(query:$query){
                    hasNextPage
                    hasPreviousPage
                    items{
                      helperMoney
                      likeCount
                      roomId
                      userId
                      userInfo
                      ipFlagStyle
                    }
                    pageIndex
                    pageSize
                    totalCount
                    totalPages
              }
            }`
    }
  },
  created() {
    this.init();
  },
  components: { 
    List,
  },
  methods: {
    init(){
      this.getOnline();
    },
    getOnline(){
      let where={
        "Equal":{
          "N":"roomId",
          "v":this.query.actId // 有直播时活动id就是房间id
        },
      }
      let order=[
        // {
        //   "N":"helperMoney",
        //   "v":0
        // },
        {
          "N":"likeCount",
          "v":0
        },
        {
          "N":"createat",
          "v":0
        },
      ]
      this.$apollo.addSmartQuery('queryLiveViewer', {
        query:this.online, 
        variables: {
          query:{
            page:this.pageIndex,
            size:this.pageSize,
            where:JSON.stringify(where),
            order:JSON.stringify(order)
          }
        },
        fetchPolicy:'no-cache',
        result(res) {
          if(res.data.queryLiveViewer.items){
              let currentList = res.data.queryLiveViewer.items;
              currentList.map(el=>{
                if(el.ipFlagStyle && el.ipFlagStyle.indexOf('css_flag') !==-1){
                  el.ipFlagStyle = 'cn'
                }
                if(el.ipFlagStyle) {
                  el.ipFlagStyle = el.ipFlagStyle.toLowerCase();
                }
              })
              if(this.pageIndex == 1){
                this.dataList = currentList;
              } else {
                this.dataList = [...this.dataList,...currentList]
              }
              this.loading = false;
              if (!res.data.queryLiveViewer.hasNextPage) {
                this.finished = true;
              }
          }
          console.log(this.dataList,'在线观众')
        },// 错误处理
        error(error) {
            console.error(error,'error错误处理')
        }
      })
    },
    loadMore() {
      if (this.finished) return;
      this.pageIndex += 1;
      console.log(this.pageIndex,'当前加载的页面')
      this.getOnline();
    },
    linkTo(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.ly{
  overflow-y: auto;
}
.lo {
  .lo-title {
    line-height: 0.9rem;
    font-size: 0.26rem;
    color: #333;
    text-align: center;
  }
  .lo-item {
    display: flex;
    align-items: center;
    padding: 0.26rem 0.28rem 0.28rem 0;
    margin-left: .28rem;

    border-top: 0.01rem solid #f2f2f2;
    &:last-child {
      border-bottom: 0.01rem solid #f2f2f2;
    }
    &:first-child {
      border-top: none;
    }

    .loi-info {
      display: flex;
      flex: 1;
      align-items: center;
      font-size: 0.26rem;
      color: #333;
      width: 50%;
      min-width: 4rem;
      display: flex;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .avatarUrl {
        width: 0.58rem;
        height: 0.58rem;
        background-color: #fff;
        border-radius: 50%;
        border: solid 0.02rem #ccc;
        display: inline-block;
        margin-right: 0.28rem;
      }
    }
    .loi-box {
      display: flex;
      align-items: center;
    }
    .loi-brand {
      display: flex;
      align-items: center;
      border-right: 0.01rem solid #f2f2f2;
      padding: 0 0.2rem;
      &:last-child {
        border-right: none;
      }
      img {
        width: 0.28rem;
        display: inline-block;
        margin-right: 0.1rem;
      }
    }
  }
  .lo-item:nth-child(1){
    .loi-info{
      .avatarUrl{
        border: solid 0.02rem #ff3600;
      }
    }
  }
  .lo-item:nth-child(2){
    .loi-info{
      .avatarUrl{
        border: solid 0.02rem #ff6e1d;
      }
    }
  }
  .lo-item:nth-child(3){
    .loi-info{
      .avatarUrl{
        border: solid 0.02rem #ffc62c;
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>